<mat-slider [style.flex]="1"
            [min]="props.min"
            [max]="props.max"
            [step]="props.step"
            [discrete]="false">
  <input matSliderThumb
         [formControl]="formControl">
</mat-slider>